export class designationUpdateRequest {
    designationId?:number;
    designation:string;
   
    createdUser:number | null;
    updatedUser: number | null;
    versionFlag: number;
  }
  export class designationIdRequest {
    designationId:string;
    updatedUser: number | null;
    versionFlag: number;
  }
  export class designationStatusUpdateRequest{
    designation:string;
    status:boolean;
  }